module.exports = __webpack_public_path__ + "img/SubNetwork.abcdd4e4.svg";